import React from 'react'
import PropTypes from 'prop-types'

import { Tabs, Tab, Box, Typography, Zoom, Tooltip } from '@material-ui/core'

import useStyles from './styles'

const a11yProps = (index) => ({
  id: `scrollable-force-tab-${index}`,
  'aria-controls': `scrollable-force-tabpanel-${index}`,
})

const TabPanel = (props) => {
  const {
    children,
    value,
    index,
    handleGlobalHeight,
    globalHeight,
    ...other
  } = props

  const ref = React.useRef()

  const refHeight = ref.current && ref.current.getBoundingClientRect().height

  React.useEffect(() => {
    if (refHeight > globalHeight) {
      handleGlobalHeight(refHeight)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refHeight])

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      <div
        style={{
          padding: 24,
          overflow: 'hidden',
          height: '100%',
          // minHeight: globalHeight !== 0 && globalHeight,
        }}
        ref={ref}
      >
        {children}
      </div>
    </Typography>
  )
}

const TabsComponent = ({ tabs, fullWidthTab }) => {
  const classes = useStyles({ fullWidthTab })
  const [value, setValue] = React.useState(0)
  const [globalHeight, setGlobalHeight] = React.useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  const filteredTabs = tabs.filter(({ renders }) => renders)

  const handleGlobalHeight = React.useCallback((heightFromComponent) => {
    setGlobalHeight(heightFromComponent)
  }, [])

  return (
    <>
      <Box display="flex" justifyContent="flex-end">
        <Tabs
          classes={{ root: classes.tabWrapper }}
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="on"
          aria-label="scrollable table"
        >
          {filteredTabs.map(({ title, icon }, i) => (
            <Tooltip key={i} TransitionComponent={Zoom} title={title}>
              <Tab
                fullWidth
                key={i}
                label={title}
                icon={icon}
                {...a11yProps(i)}
                classes={{ root: classes.tab }}
                className={
                  value === i ? classes.selectedTab : classes.unselectedTab
                }
              />
            </Tooltip>
          ))}
        </Tabs>
      </Box>
      {filteredTabs.map(({ component }, i) => (
        <TabPanel
          key={i}
          value={value}
          index={i}
          handleGlobalHeight={handleGlobalHeight}
          globalHeight={globalHeight}
          classes={{ root: classes.tabPanel }}
        >
          {value === i && component}
        </TabPanel>
      ))}
    </>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
}

TabsComponent.propTypes = {
  tabs: PropTypes.any.isRequired,
}

export default TabsComponent
